import React, {Fragment, useState, useEffect } from "react";
import Head from 'next/head'
import Header from '@/components/navbars/NavbarZero'
import EventOne from '@/components/events/EventOne';
import EventTwo from '@/components/events/EventTwo';
import EventThree from '@/components/events/EventThree';
import EventFour from '@/components/events/EventFour';
import EventFive from '@/components/events/EventFive';
import EventSix from '@/components/events/EventSix';
import EventSeven from '@/components/events/EventSeven';
import Skeleton from "@mui/material/Skeleton";
import { Container, Typography, Grid, Stack, IconButton, Tooltip, Box } from '@mui/material';
import { nanoid } from "nanoid";
import Footer from '@/components/common/Footer'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useAppContext } from '../AppContext';
import axios from "axios";
import { useTheme } from '@mui/material/styles'
import CalendarMonth from "@mui/icons-material/CalendarMonth";
import ListAltOutlined from "@mui/icons-material/ListAltOutlined";
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import momentPlugin from '@fullcalendar/moment'
import moment from 'moment';
import { useRouter } from 'next/router'

const renderEventCard = (type, event) => {
  switch(type){
    case 1: return <div data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100"><EventOne data={event}/></div>;
    case 2: return <div data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100"><EventTwo data={event}/></div>;
    case 3: return <div data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100"><EventThree data={event}/></div>;
    case 4: return <div data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100"><EventFour data={event}/></div>;
    case 5: return <div data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100"><EventFive data={event}/></div>;
    case 6: return <div data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100"><EventSix data={event}/></div>;
    case 7: return <div data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100"><EventSeven data={event}/></div>;
    default: return <div data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100"><EventOne data={event}/></div>;
  };
};

export async function getServerSideProps(context) {
  context.res.setHeader(
    'Cache-Control',
    `public, s-maxage=1, stale-while-revalidate=${process.env.CACHE_DURATION}`
  );

  const whiteLabelUrl = context.req.headers.host
  return {
    props: {
      url:whiteLabelUrl,
    }
  }
}

export default function Events(props) {
  const theme = useTheme();
  const Router = useRouter();
  const [loading, setLoading] = useState(true);
  const [themeCss, setThemeCss] = useState(null);
  const [listEvents, setListEvents] = useState([])
  const [viewType, setViewType] = useState(1)
  const [calendarEventsList, setCalendarEventsList] = useState([])

  const { url, themeData, siteData,  themeLoading, siteLoading, themeError, siteError, changeUrl, updateThemeData, updateSiteData } = useAppContext();

  useEffect(()=>{
    changeUrl(props.url);
    fetchListEvents(props.url);
  },[url]);

  const styles = {
    body: {
      backgroundColor: theme.palette.background.default,
      contrastText: theme.palette.primary.contrastText,
    },
  };

  useEffect(()=>{
    document.body.style.backgroundColor = styles.body.backgroundColor;
    document.body.style.color = styles.body.contrastText;
    if(siteData&&siteData.club_inner[0].events_only == 1){
      Router.push('/')
    }

  },[]);

  const fetchListEvents = async(url) => {
    setLoading(true);
    await axios.get(`/api/eventsPage/events?whiteLabelUrl=${url}`,{
      headers:{
        'x-auth-token':process.env.JWT_TOKEN
      }
    }).then((response)=>{
      setListEvents(response.data.upcoming_events ? response.data.upcoming_events : []);
      setLoading(false)
    })
  }

  useEffect(()=>{
    let custom_css = themeData && themeData ? JSON.parse(themeData && themeData.custom_css): null;
    setThemeCss(custom_css);
  }, [themeData]);

  useEffect(()=>{
    AOS.init();
    AOS.refresh();
    let w = window.innerWidth;
    if(w<768){
      setViewType(1)
    }
  },[]);

  useEffect(()=>{
    if(listEvents){
      let eventsList = [];
      listEvents.forEach(event => {
        let startDate = event.only_today !== '' && event.only_today !== '0000-00-00' ? moment(event.only_today).format("YYYY-MM-DD") : moment(event.from_date).format("YYYY-MM-DD");
        let endDate = event.only_today !== '' && event.only_today !== '0000-00-00' ? moment(event.only_today).format("YYYY-MM-DD") : moment(event.to_date).format("YYYY-MM-DD");
        for (let date = moment(startDate); date.isSameOrBefore(endDate); date.add(1, 'day')) {
            eventsList.push({
              id: nanoid(20),
              title: event.title,
              start: moment(date).format("YYYY-MM-DD") + ' ' + event.start_time,
              end: moment(date).format("YYYY-MM-DD") + ' ' + event.end_time,
              borderColor: `${theme.palette.background.alternate}`,
              textColor: `${themeCss && themeCss.theme_main_color}`,
              _id: event.id,
              slug: event.slug,
              allDay: true
            });
        }
      });
      setCalendarEventsList(eventsList) 
    }
  },[listEvents])


  const HomeEventsContainer = {
    py:4,
    minHeight:`70vh`,
    '& h2':{
       fontFamily: themeCss ? (themeCss.theme_primary_font).replace("+"," ") : '',
       fontSize:35,
       fontWeight:700,
       pb:5,
    },
    '& h4':{
      fontFamily: themeCss ? (themeCss.theme_primary_font).replace("+"," ") : '',
      fontSize:25,
      fontWeight:700,
      pb:5,
   }
  };

  const activeViewTypeBtn = {
    '&.MuiIconButton-root':{
      background: themeCss && themeCss.theme_main_color,
      color: theme.palette.background.default
    }
  }
  const viewTypeBtn = {
    '&.MuiIconButton-root':{
      background: theme.palette.background.alternate,
      color: theme.palette.primary.contrastText,
      transition:`0.5s`
    },
    "&:hover":{
      background: themeCss && themeCss.theme_main_color,
      color: theme.palette.background.alternate,
      transition:`0.5s`
    }
  }

  const calendarView = {
    "& .fc-daygrid-day":{
      height: 100
    },
    '& .fc-theme-standard .fc-scrollgrid':{
      border: `1px solid transparent`,
      borderRadius: 3,
      boxShadow: theme.shadows[5],
    },
    '& .fc-theme-standard td':{
      border: `6px solid transparent`,
      background: `${theme.palette.background.default} !important`
    },
    '& .fc-theme-standard th':{
      border: `6px solid transparent`,
      borderBottom: `1px solid transparent`,
      borderRadius: `25px 25px 0 0 !important`,
      "& .fc-scrollgrid-sync-inner":{
        padding: 1,
        background: themeCss&& themeCss.theme_main_color,
        borderRadius: 3
      }
    },
    '& .fc-content':{
      display:'block',
      background: `transparent !important`,
      borderColor: `transparent !important`,
      color: theme.palette.primary.contrastText,
      cursor:'pointer'
    },
    "& .fc-daygrid-day-top":{
      color: theme.palette.primary.contrastText,
      display:'inline',
      p: 1,
      fontWeight: 100,
      opacity:0.5
    },
    
    "& .fc .fc-col-header-cell-cushion":{
      textTransform:'uppercase',
      fontWeight: 100,
      fontSize:12
    },
    "& .fc .fc-toolbar.fc-header-toolbar":{
      mb:1,
    },
    "& .fc .fc-button-primary":{
      background: themeCss&& themeCss.theme_main_color,
      textTransform:'capitalize',
      fontFamily: themeCss ? (themeCss.theme_body_font).replace("+"," ") : '',
    },
    "& .fc .fc-daygrid-event":{
      px:1,
      "& .fc-event-title":{
        textTransform:'capitalize !important',
        fontWeight: 100
      },
      "& .fc-daygrid-event-dot":{
        borderColor: `${themeCss&& themeCss.theme_main_color} !important`
      }
    },
    "& .fc-day-past":{
      "& .fc-scrollgrid-sync-inner":{
        py:1,
        background: `${theme.palette.primary.contrastText}24`,
        borderRadius: 3,
        // height:25,
        border:`1px solid ${theme.palette.primary.contrastText}77`,
      },
      "& .fc-daygrid-day-events":{
        display:'none',
        "& a":{
          display:'none',
        }
      }
    },
    "& .fc-day-today":{
      "& .fc-scrollgrid-sync-inner":{
        py:1,
        border:`1px solid ${theme.palette.primary.contrastText}77`,
        background: `${theme.palette.primary.contrastText}24`,
        borderRadius: 3,
        boxShadow: theme.shadows[5],
        backdropFilter: `blur(35px)`,
        // height:20,
      },
      "& .fc-daygrid-day-top":{
        color: themeCss&& themeCss.theme_main_color,
        display:'inline',
        p: 1,
        fontWeight: 900,
        opacity:1
      },
    },
    
    "& .fc-day-future":{
      "& .fc-scrollgrid-sync-inner":{
        py:1,
        border:`1px solid ${theme.palette.primary.contrastText}77`,
        background: `${theme.palette.primary.contrastText}24`,
        borderRadius: 3,
        boxShadow: theme.shadows[5],
        backdropFilter: `blur(35px)`,  
        // maxHeight:25,      
      },
      "& .fc-daygrid-day-top":{
        color: themeCss&& themeCss.theme_main_color,
        display:'inline',
        p: 1,
        fontWeight: 900,
        opacity:1
      },
    }
  }
  
  let skeletonCards = Array(6).fill(0);

  const handleViewType = (event, value) => {
    event.preventDefault();
    setViewType(value)
  }

  const getCurrentEvent = (info) => {
    let x = calendarEventsList.filter((item)=>{
      return item.title == info.event.title
    });
    Router.push(`/event/${x[0].slug}/${x[0]._id}`)
  }

    function renderEventContent(event) {
      if (event.event.start < event.event.end) {
        return {
            html: `<div class="fc-content"><span style=display:inline-block;margin-right:5px;width:8px;height:8px;background:${themeCss && themeCss.theme_main_color}></span>${event.event.title.length > 15 ? event.event.title.substring(0,14)+"...":event.event.title}</div>`
        };
      } else {
        return {
          html: `<div class="fc-content"><span style=display:inline-block;margin-right:5px;width:8px;height:8px;background:${themeCss && themeCss.theme_main_color}></span>${event.event.title.length > 15 ? event.event.title.substring(0,14)+"...":event.event.title}</div>`
        };
      }
    }


  return (
    <Fragment>
      <Head>
        <title>{siteData && siteData.club_inner[0].restaurantTitle} - Book Upcoming Event Tickets | Upcoming Events</title>
        <meta property="og:title" content={`${siteData && siteData.club_inner[0].restaurantTitle} - Book Upcoming Event Tickets`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={siteData && siteData.club_inner[0].white_label_url ? siteData && siteData.club_inner[0].white_label_url : ''} />
        <meta property="og:image" content={siteData && siteData.sections[0].home_banner ? siteData && siteData.sections[0].home_banner : ''} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:description" content={`Unleash the night at ${siteData && siteData.club_inner[0].restaurantTitle ? siteData && siteData.club_inner[0].restaurantTitle : ''}. Explore our electrifying events in ${siteData && siteData.club_inner[0].areaName ? siteData && siteData.club_inner[0].areaName : ''}. Book your tickets, reserve your spot, and get ready for an unforgettable night of music, dancing, and non-stop entertainment.`} />
      </Head>
      <Header />
        <Container maxWidth="lg" sx={HomeEventsContainer}>
          {loading ? (
              <Grid container spacing={3}>
                {skeletonCards.map((index) => (
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}  key={nanoid(30)} >
                    <Typography component="div" sx={{background:'#5d5d5d87',p:2, borderRadius:2}}>
                      <Skeleton
                        animation="wave"
                        variant="rectangular"
                        height={200}
                        sx={{ borderRadius: 0 }}
                      />
                      <Stack sx={{ mt: 3 }}>
                        <Skeleton
                          animation="wave"
                          variant="h3"
                          sx={{ color: "grey.900" }}
                        />
                      </Stack>
                      <Stack
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "row",
                          mt: 3,
                          mb: 3,
                        }}
                      >
                        <Skeleton
                          animation="wave"
                          width="40%"
                          variant="body1"
                          sx={{ color: "grey.900" }}
                        />
                        <Skeleton
                          animation="wave"
                          width="40%"
                          variant="body1"
                          sx={{ color: "grey.900" }}
                        />
                      </Stack>
                    </Typography>
                  </Grid>
                ))}
              </Grid>   
          ):(
            <>
              {listEvents.length > 0 ? (
                <>
                <Stack display="flex" flexDirection="row" justifyContent="space-between">
                  <Typography variant="h2" sx={{flexGrow:1}}>Upcoming Events</Typography>
                  {siteData && siteData.sections[0].events_type == 7 ? (
                    <Typography component="div" className="desktopMode">
                      <Grid container spacing={1}>
                        <Grid item xs={6} >
                          <Tooltip title="List View">
                            <IconButton 
                              sx={viewType == 1 ? activeViewTypeBtn : viewTypeBtn}
                              onClick={(e)=>handleViewType(e,1)}
                            >
                              <ListAltOutlined />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                        <Grid item xs={6} >
                          <Tooltip title="Calendar View">
                            <IconButton 
                              sx={viewType == 2 ? activeViewTypeBtn : viewTypeBtn}
                              onClick={(e)=>handleViewType(e,2)}
                            >
                              <CalendarMonth />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Typography>
                  ):('')}
                </Stack>
                  {viewType == 1 ? (
                    <Box>
                      <Typography component="div">
                        <Grid container spacing={2}>
                          {listEvents.map((event) => (
                            <>
                              {
                              siteData && siteData.sections[0].events_type == 1 || 
                              siteData && siteData.sections[0].events_type == 2 || 
                              siteData && siteData.sections[0].events_type == 3 ||
                              siteData && siteData.sections[0].events_type == 4 ||
                                siteData && siteData.sections[0].events_type == 5 ? (
                                  <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                      {renderEventCard(siteData && siteData.sections[0].events_type, event)}
                                  </Grid>
                              ):(
                                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                      {renderEventCard(siteData && siteData.sections[0].events_type, event)}
                                  </Grid>
                              )}
                            </>
                          ))}
                        </Grid>
                      </Typography>
                    </Box>
                  ):(
                    <Box sx={calendarView}>
                      <FullCalendar
                        plugins={[ dayGridPlugin, momentPlugin ]}
                        initialView="dayGridMonth"
                        events={calendarEventsList ? calendarEventsList : null}
                        eventClick={(event)=>getCurrentEvent(event)}
                        eventContent={(event)=>renderEventContent(event)}
                        headerToolbar={{
                          center: '',
                          start: 'title',
                          end: 'today,prev,next',
                        }}
                        selectable={false}
                        eventDisplay="list-item"
                        validRange= {{
                          start: 'today'
                       }}
                      />
                    </Box>
                  )}
                </>
              ):(''
                // <Typography variant="h4">No Events Found</Typography>
              )}
            </>
          )}
        </Container>
      <Footer />
    </Fragment>
  )
}
